import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import Assestment3 from '../../assets/image/assestment3.png'
import online_psychologi_image from '../../assets/image/assestment/online_psychologi.jpg'
export default class online_pshychologi extends Component {
    render() {
        const image=[
            {image:online_psychologi_image}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Assessment','Online Psychological']} image={image} title="Online Psychological Test" subtitle="We handle your awarding ceremony, top management seminars, public seminars, mega seminar, and workshops. We also manage all logistics involved in making successful and professional events."/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Talentlytica Psychograph Analytics is most determined to provide the services related to psychometric analytics best to fit your needs.<br/>
                                <b>Easy Access</b><br/>
                                For our services to be accessible and easy is what we aim for, for you.
                                <br/><br/>
                                <b>Instant Result</b><br/>
                                As soon as your future candidates finish the tests, the reports can be sent straight to your hands!
                                <br/><br/>
                                <b>Secure Data</b><br/>
                                Don’t worry about your data being scattered, because with our most refined cloud system, everything will be surely secured!
                                <br/><br/>
                                <b>Integrated System</b><br/>
                                You only have your phone with you? No fear, your results can still be accessed with our mobile-friendly system!
                                <br/><br/>
                                <b>Verified Result</b><br/>
                                he results of the tests will be assured by the utmost professional and respectful experts in their field.
                                <br/>
                                Implementation Steps
                                <br/><br/>
                                <div style={{width:'100%',textAlign:'center'}}>
                                    <img src={Assestment3} style={{width:'100%'}}/>
                                </div>
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
